/**
 * Liglaにイベントを送信
 * @param pageType ページタイプ (detail | basket | fav | last_cv | cv_gift | cv_self)
 * @param productSlug 商品のslug (productモデルのslugフィールド)
 * @param url オプション：URL
 */
export const trackLiglaAutoLineEvent = (
  pageType: "basket" | "fav" | "detail" | "last_cv" | "other",
  productSlug: string,
  url?: string,
) => {
  try {
    const config = useRuntimeConfig()
    if (config.public.APP_ENV !== "production") return
    if (typeof window === "undefined" || typeof window.auto_line_pv_event !== "function") return
    window.auto_line_pv_event(pageType, productSlug, url || "")
  } catch (error) {
    console.error(`Liglaイベント送信エラー (${pageType}):`, error)
  }
}
